enum DevicesRoutes {
  Devices = 'devices',
  AdminDevices = 'management/devices',
}

export default DevicesRoutes;
